import { CrudAction } from "../types/permissions";

//Maps user-friendly action names to standard CRUD operations.
export const actionAliases: Record<string, CrudAction> = {
 
  view: "read",
  see: "read",
  access: "read",
  r: "read",

  add: "create",
  new: "create",
  upload: "create",
  c: "create",

  edit: "update",
  modify: "update",
  change: "update",
  u: "update",

  remove: "delete",
  destroy: "delete",
  d: "delete",
};


export const normalizeAction = (action: string): CrudAction => {
  const lowerAction = action.toLowerCase().trim();
  
  return actionAliases[lowerAction] || (lowerAction as CrudAction);
};
